import { render, staticRenderFns } from "./_base-table.vue?vue&type=template&id=4942509e&scoped=true&"
import script from "./_base-table.vue?vue&type=script&lang=js&"
export * from "./_base-table.vue?vue&type=script&lang=js&"
import style0 from "./_base-table.vue?vue&type=style&index=0&id=4942509e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942509e",
  null
  
)

export default component.exports